// Coaching Institute — Figma frames 99:3, 105:2, 100:2, 101:2

export const COACHING_NAV = [
  { label: 'Overview',        to: '/coaching' },
  { label: 'VR Experiences',  to: '/coaching/vr-experiences' },
  { label: 'Web Learning Hub',to: '/coaching/learning-hub' },
  { label: 'Deployment',      to: '/coaching/deployment' },
];

export const COACHING_CTA = {
  primary:   { label: 'Start Deployment',  to: '/coaching/request-adoption' },
  secondary: { label: 'Project Overview',  to: '/coaching' },
};

export const COACHING_FOOTER = {
  brandNote: 'Conceptualized, designed and developed by Dr. Keyur Sorathia & team at the Embedded Interaction Lab, Department of Design, IIT Guwahati.',
  cols: [
    { title: 'Coaching Institutes', items: [
      { label: 'Overview',         to: '/coaching' },
      { label: 'VR Experiences',   to: '/coaching/vr-experiences' },
      { label: 'Web Learning Hub', to: '/coaching/learning-hub' },
      { label: 'Deployment',       to: '/coaching/deployment' },
      { label: 'Request access',   to: '/coaching/request-adoption' },
    ]},
  ],
};

// 29 Coaching Institute Overview — 99:3
export const COACHING_OVERVIEW = {
  hero: {
    eyebrow: 'FOR COACHING INSTITUTES',
    title: 'Add immersive concept learning to your institute',
    desc:  'Use Gyan Dhara as a structured experiential-learning layer for Grade 8 and 9 Science and Mathematics, without replacing your existing classes or teaching approach.',
    ctaPrimary:  { label: 'Explore Deployment', to: '/coaching/deployment' },
    ctaSecondary:{ label: 'Start Deployment',  to: '/coaching/request-adoption' },
    imageLabel:  'COACHING + IMMERSIVE LEARNING',
  },
  facts: [
    { k: 'GRADES',      v: '8 and 9' },
    { k: 'SUBJECTS',    v: 'Science + Mathematics' },
    { k: 'LANGUAGES',   v: 'English · Hindi · Assamese' },
    { k: 'USE MODEL',   v: 'Scheduled learning sessions' },
    { k: 'CORE ACCESS', v: 'Offline-first' },
  ],
  fit: {
    eyebrow: 'WHY IT MAY FIT',
    title:   'A differentiated learning layer',
    desc:    'Gyan Dhara can complement concept explanation, revision and exploratory learning in a coaching environment.',
    items: [
      { title: 'Explain difficult concepts visually', desc: 'Use interactive experiences where diagrams and verbal explanations are not enough.', color: 'purple', icon: 'Eye' },
      { title: 'Extend practice beyond worksheets',   desc: 'Provide unlimited conceptual, theoretical and applied quizzes.',                       color: 'royal',  icon: 'ClipboardList' },
      { title: 'Understand learner progress',          desc: 'Review time spent, completion and chapter-level quiz performance.',                    color: 'cyan',   icon: 'BarChart3' },
      { title: 'Create a scheduled learning slot',     desc: 'Run a dedicated Gyan Dhara period, lab session or optional enrichment block.',         color: 'mint',   icon: 'CalendarClock' },
    ],
  },
  content: {
    eyebrow: 'LEARNING CONTENT',
    title:   'Curriculum and exploration',
    desc:    'Use NCERT-aligned learning modules alongside optional exploratory experiences.',
    scienceRow: [
      { title: 'Sound',              subject: 'Science' },
      { title: 'Combustion & Flame', subject: 'Science' },
      { title: 'Friction',           subject: 'Science' },
    ],
    mathRow: [
      { title: 'Perimeter', subject: 'Mathematics' },
      { title: 'Area 2D',   subject: 'Mathematics' },
      { title: 'Volume',    subject: 'Mathematics' },
    ],
    exploreTitle: 'Exploratory experiences for enrichment',
    exploreList:  'Taj Mahal · Qutub Minar · India Gate · Age of Dinosaurs · Living World Safari · Experience Space Station · 3D Painting',
    exploreNote:  'These experiences are not presented as direct NCERT chapter matches.',
  },
  uses: {
    eyebrow: 'HOW IT CAN BE USED',
    title:   'Flexible within your programme',
    desc:    'The institute decides how frequently students use Gyan Dhara and where the sessions fit.',
    items: [
      { title: 'Concept reinforcement',   desc: 'Use after teaching a difficult chapter.',                    color: 'purple', icon: 'Lightbulb' },
      { title: 'Scheduled lab session',   desc: 'Assign a regular VR learning period.',                       color: 'royal',  icon: 'CalendarDays' },
      { title: 'Revision support',        desc: 'Combine VR with quizzes and chapter resources.',             color: 'cyan',   icon: 'RefreshCw' },
      { title: 'Exploration block',       desc: 'Offer optional interdisciplinary experiences.',              color: 'mint',   icon: 'Compass' },
    ],
  },
  essentials: {
    eyebrow: 'ADOPTION ESSENTIALS',
    title:   'A compact, scalable setup',
    desc:    'Coaching institutes receive the same software ecosystem as other adopters; hardware and logistics are funded separately.',
    items: [
      { title: 'Minimum starting setup',  desc: 'At least three Meta Quest 3S headsets with recommended straps and stools.',            color: 'purple', icon: 'Boxes' },
      { title: 'Recommended capacity',    desc: 'One headset per 20 students, with one learner using one headset at a time.',           color: 'royal',  icon: 'Users' },
      { title: 'Offline-first operation', desc: 'Core installed modules work offline; Gyan Mitra requires internet.',                    color: 'cyan',   icon: 'WifiOff' },
      { title: 'Complete software access',desc: 'No software licence fee through June 2027; updates and new modules are included.',     color: 'mint',   icon: 'CheckCircle2' },
    ],
  },
  portfolio: {
    eyebrow: 'MODULE PORTFOLIO UPDATE',
    title:   'Current and upcoming learning modules',
    desc:    'The catalogue below adds modules that were missing from this profile while preserving the existing content already shown above.',
    availableNow: [
      { title: "Gravity's Grip",         subject: 'Science' },
      { title: 'Work',                    subject: 'Science' },
      { title: 'Energy',                  subject: 'Science' },
      { title: 'Falltopia',               subject: 'Science' },
      { title: 'AeroQuest',               subject: 'Science' },
      { title: 'Human Excretory System',  subject: 'Science' },
    ],
    upcoming: [
      { title: 'Structure of Atoms',           subject: 'Science' },
      { title: 'Area of Cone',                 subject: 'Mathematics' },
      { title: 'Area of Sphere',               subject: 'Mathematics' },
      { title: 'Volume of Sphere and Cone',    subject: 'Mathematics' },
      { title: 'Contact & Non-contact Forces', subject: 'Science' },
      { title: 'Light',                        subject: 'Science' },
    ],
  },
  cta: {
    title: 'Discuss a coaching-centre setup that fits your learner volume.',
    desc:  'The team can prepare a customised deployment estimate covering hardware, accessories, configuration, courier and optional support.',
    primary: { label: 'Start Deployment', to: '/coaching/request-adoption' },
  },
};

// 30 Coaching Institute Learning Use — 105:2
export const COACHING_LEARNING_USE = {
  hero: {
    eyebrow: 'LEARNING USE',
    title:   'Use immersive learning with a clear academic purpose',
    desc:    'Gyan Dhara can support concept reinforcement, structured VR sessions, revision and enrichment without replacing the institute’s existing teaching programme.',
    flowLabel: 'TEACH · EXPERIENCE · PRACTISE · REVIEW',
    flowDesc:  'A connected flow from explanation to immersive understanding and progress review.',
    ctaPrimary:  { label: 'Start Deployment',  to: '/coaching/request-adoption' },
  },
  models: {
    eyebrow: 'FOUR USE MODELS',
    title:   'Choose the role Gyan Dhara plays',
    desc:    'An institute can use one or combine several models based on its teaching schedule and learner needs.',
    items: [
      { title: 'Concept reinforcement',    desc: 'Use the VR module after teaching a difficult chapter to strengthen understanding and mental models.', color: 'purple', icon: 'Brain' },
      { title: 'Scheduled VR learning',     desc: 'Create a weekly or fortnightly learning slot for small learner batches.',                              color: 'royal',  icon: 'CalendarClock' },
      { title: 'Revision and practice',     desc: 'Combine chapter revision with conceptual, theoretical and applied quizzes.',                          color: 'cyan',   icon: 'ClipboardList' },
      { title: 'Exploratory enrichment',    desc: 'Offer optional space, history, art, nature and career experiences beyond the direct curriculum.',      color: 'mint',   icon: 'Compass' },
    ],
  },
  journey: {
    eyebrow: 'LEARNING JOURNEY',
    title:   'From chapter selection to progress',
    desc:    'The experience connects VR learning with continued practice and review.',
    steps: [
      { n: '01', title: 'Select the chapter',    desc: 'Choose the curriculum concept or enrichment experience.',            color: 'purple' },
      { n: '02', title: 'Prepare the learner',   desc: 'Use the learner account and complete the first-use orientation.',   color: 'royal' },
      { n: '03', title: 'Learn in VR',           desc: 'One learner uses one headset for approximately 35–45 minutes.',      color: 'cyan' },
      { n: '04', title: 'Practise and continue', desc: 'Use quizzes, videos, visual PDFs and Gyan Mitra.',                    color: 'mint' },
      { n: '05', title: 'Review progress',       desc: 'See time, completion and quiz performance by learning type.',         color: 'purple' },
    ],
  },
  session: {
    eyebrow: 'A SAMPLE SESSION',
    title:   'Designed around individual learning',
    desc:    'The institute can adjust the timetable, but the learning sequence should remain focused and manageable.',
    rows: [
      { label: 'BEFORE', title: 'Select chapter and prepare charged devices.',    time: '10 min setup', color: 'purple' },
      { label: 'DURING', title: 'One learner completes the guided VR experience.', time: '35–45 min',    color: 'royal' },
      { label: 'AFTER',  title: 'Complete quiz practice or review chapter resources.', time: 'Flexible', color: 'cyan' },
      { label: 'LATER',  title: 'Check completion, time and learning-type scores.', time: 'Dashboard',    color: 'mint' },
    ],
  },
  ecosystem: {
    eyebrow: 'LEARNING ECOSYSTEM',
    title:   'Continue beyond the headset',
    desc:    'The VR module is one part of a connected learning experience.',
    items: [
      { key: 'VR', title: 'Immersive modules',           desc: 'Guided Science and Mathematics learning.',       color: 'purple' },
      { key: '?',  title: 'Unlimited quizzes',            desc: 'Conceptual, theoretical and applied practice.',  color: 'royal' },
      { key: '▶',  title: 'Videos and visual resources',  desc: 'Chapter explanations, images and visual PDFs.',  color: 'cyan' },
      { key: 'AI', title: 'Gyan Mitra',                   desc: 'Voice and visual Q&A when internet is available.', color: 'purple' },
      { key: '⌬',  title: 'Teacher dashboard',            desc: 'Completion, time and quiz performance.',         color: 'royal' },
      { key: '⇪',  title: 'Uploaded materials',           desc: 'Teachers can add their own learning resources.',  color: 'mint' },
    ],
  },
  examples: {
    eyebrow: 'CONTENT EXAMPLES',
    title:   'Curriculum first, exploration optional',
    desc:    'Institutes can build their timetable around chapter-aligned learning and use exploration as enrichment.',
    items: [
      { title: 'Sound',              subject: 'Science' },
      { title: 'Combustion & Flame', subject: 'Science' },
      { title: 'Friction',           subject: 'Science' },
      { title: 'Perimeter',          subject: 'Mathematics' },
      { title: 'Area 2D',            subject: 'Mathematics' },
      { title: 'Volume',             subject: 'Mathematics' },
    ],
  },
  cta: {
    title: 'Plan a learning-use model for your coaching institute.',
    desc:  'Discuss learner volume, timetable and preferred session pattern with the Gyan Dhara team.',
    primary: { label: 'Start Deployment', to: '/coaching/request-adoption' },
  },
};

// 31 Coaching Institute Adoption — 100:2
export const COACHING_ADOPTION = {
  hero: {
    eyebrow: 'DEPLOYMENT & SETUP',
    title:   'Start small and scale with learner demand',
    desc:    'A coaching institute can begin with a compact setup, schedule structured sessions and add more headsets as usage grows.',
    ctaPrimary: { label: 'Start Deployment', to: '/coaching/request-adoption' },
    metricEyebrow: 'HEADSETS TO START',
    metricNote:    'Scalable from a compact portable setup',
    metricValue:   '3+',
  },
  minimum: {
    eyebrow: 'MINIMUM STANDARD',
    title:   'The recommended starting point',
    desc:    'A consistent setup supports comfort, device readiness and remote configuration.',
    items: [
      { title: 'Meta Quest 3S headsets', k: '3+', desc: 'Minimum starting quantity for a coaching-centre deployment.',      color: 'purple' },
      { title: 'Students per headset',    k: '20', desc: 'Recommended planning ratio; one learner uses one headset at a time.', color: 'royal' },
      { title: 'Rotating stools',         k: '3+', desc: 'Recommended for comfortable seated interaction during longer sessions.', color: 'cyan' },
      { title: 'Comfort straps',          k: '3+', desc: 'Recommended for fit, hygiene and repeat use by multiple learners.', color: 'mint' },
    ],
  },
  separation: {
    eyebrow: 'SOFTWARE AND FUNDED COMPONENTS',
    title:   'A clear separation',
    desc:    'The learning software is provided without a licence fee through June 2027. Hardware and deployment logistics are separately funded.',
    included: {
      title: 'Included software ecosystem',
      items: [
        'All available curriculum VR modules',
        'Exploratory learning experiences',
        'New modules and software updates',
        'Student and teacher websites',
        'Unlimited conceptual, applied and theoretical quizzes',
        'Chapter videos and visual resources',
        'Learning analytics',
        'Gyan Mitra when internet is available',
      ],
    },
    funded: {
      title: 'Funded by the institute',
      items: [
        'Meta Quest 3S headsets',
        'Comfort straps and accessories',
        'Rotating stools',
        'Device configuration and management',
        'Packaging, courier and logistics',
        'Optional casting display',
        'Optional training and technical support',
        'Repair and replacement',
      ],
    },
  },
  operating: {
    eyebrow: 'OPERATING MODEL',
    title:   'Simple day-to-day use',
    desc:    'The institute controls scheduling while the Gyan Dhara team manages software preparation and updates.',
    steps: [
      { title: 'Plan sessions',           desc: 'Create a timetable based on learner groups and available headsets.',        color: 'purple', icon: 'CalendarClock' },
      { title: 'Prepare devices',          desc: 'Charge, store and keep the configured headsets ready.',                     color: 'royal',  icon: 'Battery' },
      { title: 'Run individual sessions',  desc: 'One learner uses one headset for approximately 35–45 minutes.',              color: 'cyan',   icon: 'UserCircle' },
      { title: 'Review learning',          desc: 'Use accounts and dashboards to review activity and quiz performance.',       color: 'mint',   icon: 'BarChart3' },
    ],
  },
  pathway: {
    eyebrow: 'DEPLOYMENT PATHWAY',
    title:   'Four stages to begin',
    desc:    'After confirmation and transfer of applicable hardware and logistics costs, setup can generally begin within 7–10 days.',
    stages: [
      { n: 1, title: 'Submit interest',       desc: 'Share institute and learner details.',                      color: 'purple' },
      { n: 2, title: 'Discuss setup',         desc: 'Confirm headsets, accessories and support.',                color: 'royal' },
      { n: 3, title: 'Agreement and payment', desc: 'Complete collaboration agreement and applicable costs.',    color: 'cyan' },
      { n: 4, title: 'Configure and dispatch',desc: 'Accounts, software and hardware are prepared and couriered.', color: 'mint' },
    ],
  },
  cta: {
    title: 'Request a customised coaching-institute deployment estimate.',
    primary: { label: 'Start Deployment', to: '/coaching/request-adoption' },
  },
};

// 32 Coaching Institute Adoption Request — 101:2
export const COACHING_REQUEST = {
  hero: {
    eyebrow: 'REQUEST ADOPTION',
    title:   'Discuss adoption for your coaching institute',
    desc:    'Share the basic institute and learner details. The team will respond within 48 hours to discuss the setup and prepare a customised estimate.',
    readinessTitle: 'Minimum readiness',
    readiness: [
      'Ability to purchase at least three Quest 3S headsets',
      'Recommended straps and stools',
      'Participation in agreed evaluation activities',
      'A coordinator for scheduling and device care',
    ],
  },
  formTitle: 'Institute details',
  formHint:  'All fields marked * are required.',
  subjects:  ['Science', 'Mathematics'],
  setupOptions: ['3 headsets', '5 headsets', '10 headsets', 'Need guidance'],
  intendedUse: ['Concept reinforcement', 'Scheduled VR sessions', 'Revision support', 'Exploratory enrichment', 'Individual learner accounts'],
  readiness: [
    'I confirm readiness to fund the required hardware, accessories and logistics.',
    'I understand that software access is provided without a licence fee through June 2027.',
    'I agree to be contacted about adoption and setup.',
  ],
  submit: 'Submit Adoption Request',
  submitNote: 'The request will be sent to keyur.sorathia@gyan-dhara.com',
  privacy:    'Information is used only to respond to this request and support the agreed setup.',
  nextTitle:  'What happens next',
  next: [
    { title: 'Request review',           desc: 'Institute and learner context' },
    { title: 'Discussion',               desc: 'Headsets, scheduling and support' },
    { title: 'Estimate and agreement',   desc: 'Hardware, logistics and responsibilities' },
    { title: 'Configuration and dispatch', desc: 'Prepared package and learner access' },
  ],
  beforeTitle: 'Before submitting',
  beforeItems: [
    { k: '3+',    title: 'Minimum setup',   desc: 'At least three headsets.' },
    { k: '20',    title: 'Planning ratio',  desc: 'One headset per 20 learners.' },
    { k: '35–45', title: 'Session length',  desc: 'One learner per headset.' },
    { k: 'OFF',   title: 'Core use',        desc: 'Modules work offline.' },
  ],
  confirmation: {
    title: 'Request received',
    body:  'The application is under review. The Gyan Dhara team will respond within 48 hours.',
    cta:   { label: 'Return to Coaching Overview', to: '/coaching' },
  },
};
